import { render } from "./HorizontalBarChart.vue?vue&type=template&id=b37adbb6&scoped=true"
import script from "./HorizontalBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalBarChart.vue?vue&type=script&lang=js"

import "./HorizontalBarChart.vue?vue&type=style&index=0&id=b37adbb6&lang=scss&scoped=true"
import "./HorizontalBarChart.vue?vue&type=style&index=1&id=b37adbb6&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37adbb6"]])

export default __exports__